import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'
import React, { useState } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { useAdmin } from 'services/hooks/useAdmin'

const RequiredAdmin = () => {
  const [isAdmin, isAllowed] = useAdmin()
  const navigate = useNavigate()
  const [isModalOpen, setModalOpen] = useState(!isAdmin || !isAllowed)

  const handleClose = () => {
    setModalOpen(false)
    navigate('/app/homepage')
  }

  if (isAdmin === false || isAllowed === false) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.

    return (
      <AdxInfoModal
        variant="error"
        open={isModalOpen}
        // handleClose={handleClose}
        muiIcon="error"
        iconColor="error.main"
        title="Unauthorised "
        subtitle="If you think this is a mistake, please contact your admin."
        footerButtons
        firstBtnLabel="Ok"
        firstBtnHandle={handleClose}
      ></AdxInfoModal>
    )
  }

  return <Outlet />
}

export default RequiredAdmin
